import withStyles from 'isomorphic-style-loader/withStyles';
import React from 'react';

import DefaultBanner from '../../../components/DefaultBanner';

import {
  Grid,
  Row,
  Col,
} from '../../../incubation/components/ResponsiveGridLayout';

import s from './CookieCruncher.scss';

class CookieCruncher extends React.Component {
  render() {
    return (
      <React.Fragment>
        <DefaultBanner
          breadcrumb={
            <ul
              className="breadcrumb"
              itemScope
              itemType="https://schema.org/BreadcrumbList"
            >
              <li
                itemProp="itemListElement"
                itemScope
                itemType="https://schema.org/ListItem"
              >
                <a
                  href="https://fluxtech.co/"
                  itemProp="item"
                  itemType="https://schema.org/Thing"
                >
                  <span itemProp="name">Home</span>
                </a>
                <meta content="0" itemProp="position" />
              </li>
              <li
                itemProp="itemListElement"
                itemScope
                itemType="https://schema.org/ListItem"
              >
                <a
                  href="https://fluxtech.co/portfolio/"
                  itemProp="item"
                  itemType="https://schema.org/Thing"
                >
                  <span itemProp="name">Portfolio</span>
                  <meta content="1" itemProp="position" />
                </a>
              </li>
              <li>Cookie Cruncher</li>
            </ul>
          }
          header="Cookie Cruncher"
          subHeader="Cookie destruction at its finest"
        />
        <section className={s.game}>
          <Grid>
            <Row>
              <Col md={12}>
                <h4>
                  Cookie Cruncher is the ultimate cookie-destruction mobile game
                  available now for iPhone & Android.
                </h4>
              </Col>
              <Col md={12}>
                <div className={s.home}>
                  <div className={s.image}>
                    <img
                      alt="Home Screen"
                      // eslint-disable-next-line
                      src="https://static1.squarespace.com/static/5b7740155cfd793fbf822548/5b9022bb4ae237cea458ab16/5b9025bd1ae6cffa3ad709aa/1536173692168/iPhoneX-CC-07.png?format=1000w"
                    />
                  </div>
                  <div className={s.content}>
                    <h3>Home Screen</h3>
                    <p>
                      Tap the giant cookie to take bites - get the ‘Cookies
                      Left’ number down to zero!
                    </p>
                  </div>
                </div>
              </Col>
              <Col md={12}>
                <div className={s.contract}>
                  <div className={s.content}>
                    <h3>Contract</h3>
                    <p>
                      Complete challenges to earn money! Money is used to remove
                      cookies more efficiently!
                    </p>
                  </div>
                  <div className={s.image}>
                    <img
                      alt="Contracts"
                      // eslint-disable-next-line
                      src="https://static1.squarespace.com/static/5b7740155cfd793fbf822548/5b9022bb4ae237cea458ab16/5b9025e5cd8366f9c0988559/1536173723768/iPhoneX-CC-10.png?format=1000w"
                    />
                  </div>
                </div>
              </Col>
              <Col md={12}>
                <div className={s.events}>
                  <div className={s.image}>
                    <img
                      alt="Events"
                      // eslint-disable-next-line
                      src="https://static1.squarespace.com/static/5b7740155cfd793fbf822548/5b9022bb4ae237cea458ab16/5b9025e80e2e72642f98d419/1536173782062/iPhoneX-CC-09.png?format=1000w"
                    />
                  </div>
                  <div className={s.content}>
                    <h3>Events</h3>
                    <p>
                      Events appear randomly. They give you a chance to either
                      earn money or eat tons of cookies for a limited time -
                      Keep the event going by eating cookies quickly!
                    </p>
                  </div>
                </div>
              </Col>
              <Col md={12}>
                <div className={s.trophies}>
                  <div className={s.content}>
                    <h3>Trophies</h3>
                    <p>
                      Get trophies by eating cookies quickly, acquire lots of
                      upgrades, or beat the game!
                    </p>
                  </div>
                  <div className={s.image}>
                    <img
                      alt="Trophies"
                      // eslint-disable-next-line
                      src="https://static1.squarespace.com/static/5b7740155cfd793fbf822548/5b9022bb4ae237cea458ab16/5b9025eb1ae6cffa3ad70cb8/1536173819965/iPhoneX-CC-08.png?format=1000w"
                    />
                  </div>
                </div>
              </Col>
              <Col md={12}>
                <div className={s.design}>
                  <div className={s.image}>
                    <img
                      alt="Design Store"
                      // eslint-disable-next-line
                      src="https://static1.squarespace.com/static/5b7740155cfd793fbf822548/5b9022bb4ae237cea458ab16/5b9025f0032be406ee3fb63a/1536173859583/iPhoneX-CC-06.png?format=1000w"
                    />
                  </div>
                  <div className={s.content}>
                    <h3>Design Store</h3>
                    <p>
                      Buy different background themes and cookie skins from the
                      in-game Design Store!
                    </p>
                  </div>
                </div>
              </Col>
              <Col md={12}>
                <div className={s.upgrades}>
                  <div className={s.content}>
                    <h3>Upgrades</h3>
                    <p>
                      Buy unique upgrades with in-game money to provide benefits
                      and special boosts that assist in your cookie-destructive
                      ways!
                    </p>
                  </div>
                  <div className={s.image}>
                    <img
                      alt="Upgrades"
                      // eslint-disable-next-line
                      src="https://static1.squarespace.com/static/5b7740155cfd793fbf822548/5b9022bb4ae237cea458ab16/5b9027082b6a287f012a67a3/1536173911119/iPhoneX-CC-11.png?format=1000w"
                    />
                  </div>
                </div>
              </Col>
              <Col md={12}>
                <h4>Download </h4>
                <div className={s.linkContainer}>
                  <a href="https://play.google.com/store/apps/details?id=com.FatalStudios.CookieCruncher">
                    Google Play
                  </a>
                  <a href="https://itunes.apple.com/us/app/cookie-cruncher/id1435718945?ls=1&amp;mt=8">
                    Apple Store
                  </a>
                </div>
              </Col>
              <Col md={12}>
                <div className={s.promo}>
                  <h4>Designed and developed in partnership with</h4>
                  <a href="https://fatalstudios.com/">
                    <img
                      alt="Fatal Studios"
                      src="//static1.squarespace.com/static/5b7740155cfd793fbf822548/t/5bec9d60f950b725c708e4bf/1545863280640/?format=1500w"
                    />
                  </a>
                </div>
              </Col>
            </Row>
          </Grid>
        </section>
      </React.Fragment>
    );
  }
}

export default withStyles(s)(CookieCruncher);
